import React from "react";

import { IconButton, Tooltip, CircularProgress } from "@mui/material";
import { CheckCircle } from "@mui/icons-material";

import { useNotificationContext } from "contexts/NotificationContext";

import { useOnNotificationReadMutation } from "store/services/notificationApi";

import { NOTIFICATION_CONSTANTS } from "constants/notificationConstants";

const NotificationAction = ({ id }) => {
  const [isRead, setIsRead] = React.useState(false);

  const [markAsRead, { isLoading, isFetching }] =
    useOnNotificationReadMutation();

  const { dispatch: notificationDispatch } = useNotificationContext();

  const onRead = async () => {
    setIsRead(true);
    await markAsRead(id);
    notificationDispatch({
      type: NOTIFICATION_CONSTANTS.READ_NOTIFICATION,
      payload: {
        id: id,
      },
    });
  };

  const isBusy = isLoading || isFetching;

  return (
    <div className="flex flex-row gap-1">
      {isBusy ? (
        <CircularProgress size="small" />
      ) : isRead ? null : (
        <Tooltip title="Mark as read">
          <IconButton
            size="small"
            aria-label="Read Notification"
            onClick={onRead}
          >
            <CheckCircle size="small" />
          </IconButton>
        </Tooltip>
      )}
    </div>
  );
};

export default NotificationAction;
